import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoaurangabadcab() {



    const cardData = {




keyword: "Mumbai to Aurangabad Cab",

headingDescription: "Shreesha Tours & Travels provides reliable, comfortable, and affordable Mumbai to Aurangabad cab services for business travelers, families, tourists, pilgrims, students, and corporate clients. We offer one-way cabs, round-trip taxi services, airport transfers, multi-day tour packages, and customized outstation travel solutions with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury cars suitable for solo travelers, families, and large groups. With doorstep pickup anywhere in Mumbai, flexible departure schedules, transparent pricing, easy online booking, and 24/7 customer support, we ensure a safe, smooth, and hassle-free journey. Whether you are planning a visit to the UNESCO World Heritage Sites, business meetings, family vacations, religious tours, educational trips, or weekend getaways, Shreesha Tours & Travels delivers professional Mumbai to Aurangabad cab services with clean vehicles, courteous drivers, and punctual service. Travel comfortably through Maharashtra while enjoying a relaxing road trip and personalized travel experience designed to meet every customer's needs.",

topPlaces: [
  {
    title: "Ajanta Caves",
    description: "Ajanta Caves are a UNESCO World Heritage Site and one of India's greatest historical treasures. The ancient Buddhist cave temples are renowned for their magnificent paintings, intricate sculptures, and rock-cut architecture dating back more than 2,000 years. Visitors from around the world come to admire the artistic brilliance and cultural heritage preserved within these caves."
  },
  {
    title: "Ellora Caves",
    description: "Ellora Caves are among the most famous archaeological sites in India, featuring remarkable Buddhist, Hindu, and Jain rock-cut temples. The iconic Kailasa Temple, carved from a single rock, is considered one of the greatest architectural achievements in the world. It is a must-visit destination for history lovers and international tourists."
  },
  {
    title: "Bibi Ka Maqbara",
    description: "Often called the 'Mini Taj Mahal of the Deccan,' Bibi Ka Maqbara is Aurangabad's most recognized monument. Built during the Mughal era, the monument is admired for its elegant architecture, landscaped gardens, and historical significance, making it one of the city's top tourist attractions."
  },
  {
    title: "Daulatabad Fort",
    description: "Daulatabad Fort is one of Maharashtra's strongest hill forts, famous for its impressive defense system, ancient gateways, secret passages, and panoramic views. The fort offers visitors a fascinating glimpse into medieval Indian history and military architecture."
  },
  {
    title: "Grishneshwar Jyotirlinga Temple",
    description: "Grishneshwar Temple is one of the twelve sacred Jyotirlingas dedicated to Lord Shiva. Located near Ellora Caves, the temple is an important pilgrimage destination attracting devotees from across India. Its ancient architecture and spiritual atmosphere make it a significant religious landmark."
  },
  {
    title: "Panchakki",
    description: "Panchakki is a historic water mill powered by an underground water channel, showcasing remarkable medieval engineering. Surrounded by gardens and historical structures, it offers visitors an interesting combination of history, architecture, and peaceful surroundings."
  },
  {
    title: "Siddharth Garden and Zoo",
    description: "Siddharth Garden and Zoo is a popular family attraction featuring landscaped gardens, a variety of animals, children's play areas, and recreational facilities. It is an ideal destination for families traveling with children and visitors looking for a relaxing outing."
  },
  {
    title: "Paithan",
    description: "Paithan is an ancient town near Aurangabad famous for its rich cultural heritage, Paithani silk sarees, Jayakwadi Dam, and religious importance. It is a popular excursion for tourists interested in history, traditional craftsmanship, and scenic landscapes."
  },
  {
    title: "Lonar Lake",
    description: "Lonar Lake is a unique meteor-impact crater lake and one of the world's rare geological wonders. Surrounded by forests, ancient temples, and wildlife, it attracts nature lovers, photographers, researchers, and adventure enthusiasts from across the globe."
  },
  {
    title: "Shirdi",
    description: "Located within driving distance from Aurangabad, Shirdi is one of India's most visited pilgrimage destinations and home to the sacred Shri Sai Baba Samadhi Mandir. Many travelers combine Aurangabad sightseeing with a spiritual visit to Shirdi for a complete Maharashtra tour experience."
  }
],



"services": [
  {
    "name": "Mumbai to Aurangabad Cab",
    "description": "Book Mumbai to Aurangabad Cab for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova Crysta, SUV, and premium cabs for one way and round trip journeys."
  },
  {
    "name": "Aurangabad to Mumbai One Way Taxi",
    "description": "Hire Aurangabad to Mumbai One Way Taxi with fixed pricing, professional drivers, and comfortable AC vehicles for affordable single-trip travel."
  },
  {
    "name": "Aurangabad to Mumbai Taxi",
    "description": "Book Aurangabad to Mumbai Taxi for reliable long-distance transportation with experienced chauffeurs and well-maintained vehicles."
  },
  {
    "name": "One Way Cab Mumbai to Aurangabad",
    "description": "Choose One Way Cab Mumbai to Aurangabad for economical travel without return charges, offering clean vehicles and dependable service."
  },
  {
    "name": "Mumbai to Aurangabad Taxi Fare",
    "description": "Check Mumbai to Aurangabad Taxi Fare with transparent pricing, affordable packages, and no hidden charges."
  },
  {
    "name": "Mumbai to Aurangabad Taxi",
    "description": "Hire Mumbai to Aurangabad Taxi for comfortable intercity travel with experienced drivers and premium AC vehicles."
  },
  {
    "name": "Mumbai to Aurangabad One Way Taxi",
    "description": "Book Mumbai to Aurangabad One Way Taxi for budget-friendly travel with flexible pickup locations and professional chauffeurs."
  },
  {
    "name": "Mumbai to Aurangabad Car Rental",
    "description": "Choose Mumbai to Aurangabad Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, and SUV vehicles."
  },
  {
    "name": "Mumbai to Aurangabad Cab Booking",
    "description": "Complete Mumbai to Aurangabad Cab Booking online with instant confirmation and multiple vehicle choices."
  },
  {
    "name": "Mumbai Aurangabad Taxi Service",
    "description": "Book Mumbai Aurangabad Taxi Service for smooth and reliable travel with experienced drivers and comfortable vehicles."
  },
  {
    "name": "Mumbai Airport to Aurangabad Taxi",
    "description": "Reserve Mumbai Airport to Aurangabad Taxi with direct airport pickup, timely service, and professional chauffeurs."
  },
  {
    "name": "Mumbai to Sambhaji Nagar Cab",
    "description": "Hire Mumbai to Sambhaji Nagar Cab with affordable fares and comfortable vehicles for business and family travel."
  },
  {
    "name": "Mumbai to Aurangabad Taxi Fare",
    "description": "Get Mumbai to Aurangabad Taxi Fare with competitive pricing and quality chauffeur-driven transportation."
  },
  {
    "name": "Mumbai to Aurangabad Taxi Fare Per Day",
    "description": "Check Mumbai to Aurangabad Taxi Fare Per Day for flexible travel plans and affordable daily cab packages."
  },
  {
    "name": "Navi Mumbai to Aurangabad Cab",
    "description": "Book Navi Mumbai to Aurangabad Cab with reliable service, experienced chauffeurs, and comfortable vehicles."
  },
  {
    "name": "Thane to Aurangabad Cab",
    "description": "Hire Thane to Aurangabad Cab with professional drivers and premium AC vehicles for safe travel."
  },
  {
    "name": "Mumbai to Ajanta Ellora Tour Package",
    "description": "Choose Mumbai to Ajanta Ellora Tour Package with sightseeing, comfortable vehicles, and experienced chauffeurs for a memorable trip."
  },
  {
    "name": "Mumbai to Paithan Cab Service",
    "description": "Book Mumbai to Paithan Cab Service for reliable outstation transportation with clean vehicles and affordable fares."
  },
  {
    "name": "Mumbai to Aurangabad MIDC",
    "description": "Reserve Mumbai to Aurangabad MIDC Cab for business travel, industrial visits, and corporate transportation."
  },
  {
    "name": "Mumbai to Sambhajinagar Cab",
    "description": "Hire Mumbai to Sambhajinagar Cab with spacious vehicles and professional chauffeurs for comfortable travel."
  },
  {
    "name": "Mumbai to Chhatrapati Sambhajinagar Cab",
    "description": "Book Mumbai to Chhatrapati Sambhajinagar Cab with reliable long-distance taxi services and premium comfort."
  },
  {
    "name": "Mumbai to Aurangabad Cab",
    "description": "Choose Mumbai to Aurangabad Cab for safe and convenient travel with experienced drivers and transparent pricing."
  },
  {
    "name": "Mumbai to Aurangabad Taxi",
    "description": "Reserve Mumbai to Aurangabad Taxi for affordable one way and round trip travel with comfortable AC vehicles."
  },
  {
    "name": "Mumbai to Sambhajinagar Taxi Service",
    "description": "Book Mumbai to Sambhajinagar Taxi Service with flexible travel schedules and reliable chauffeur-driven transportation."
  },
  {
    "name": "Mumbai to Aurangabad Taxi Service",
    "description": "Hire Mumbai to Aurangabad Taxi Service for smooth intercity travel with premium vehicles and professional drivers."
  },
  {
    "name": "Mumbai to Sambhajinagar Cab Service",
    "description": "Choose Mumbai to Sambhajinagar Cab Service for dependable outstation travel with clean vehicles and affordable pricing."
  },
  {
    "name": "Mumbai to Aurangabad Cab Service",
    "description": "Book Mumbai to Aurangabad Cab Service with instant booking, comfortable vehicles, and experienced chauffeurs."
  },
  {
    "name": "Mumbai to Sambhajinagar One Way Cab",
    "description": "Reserve Mumbai to Sambhajinagar One Way Cab with fixed fares and no return charges for convenient travel."
  },
  {
    "name": "Mumbai to Aurangabad One Way Taxi",
    "description": "Hire Mumbai to Aurangabad One Way Taxi for economical travel with reliable drivers and comfortable vehicles."
  },
  {
    "name": "One Way Mumbai to Sambhajinagar Cab",
    "description": "Choose One Way Mumbai to Sambhajinagar Cab for affordable point-to-point travel with professional chauffeur service."
  },
  {
    "name": "Mumbai Airport to Sambhajinagar Cab",
    "description": "Book Mumbai Airport to Sambhajinagar Cab with direct airport pickup and premium chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Aurangabad Innova Crysta Cab",
    "description": "Reserve Mumbai to Aurangabad Innova Crysta Cab for luxury family and corporate travel with spacious seating."
  },
  {
    "name": "Mumbai to Sambhajinagar Ertiga Cab",
    "description": "Hire Mumbai to Sambhajinagar Ertiga Cab for affordable 6 to 7 seater travel with comfortable interiors."
  },
  {
    "name": "Mumbai to Aurangabad Outstation Taxi",
    "description": "Book Mumbai to Aurangabad Outstation Taxi with experienced chauffeurs and reliable long-distance travel service."
  },
  {
    "name": "Best Mumbai to Sambhajinagar Cab Booking",
    "description": "Choose Best Mumbai to Sambhajinagar Cab Booking with instant confirmation, affordable pricing, and premium vehicles."
  },
  {
    "name": "Mumbai to Ellora Caves Cab",
    "description": "Book Mumbai to Ellora Caves Cab for sightseeing tours with comfortable vehicles and professional chauffeurs."
  },
  {
    "name": "Mumbai to Grishneshwar Jyotirlinga Cab",
    "description": "Reserve Mumbai to Grishneshwar Jyotirlinga Cab for temple visits with reliable drivers and comfortable AC vehicles."
  }
],
"tableData": [
  ["Mumbai to Aurangabad Cab", "Aurangabad to Mumbai One Way Taxi"],
  ["Aurangabad to Mumbai Taxi", "One Way Cab Mumbai to Aurangabad"],
  ["Mumbai to Aurangabad Taxi Fare", "Mumbai to Aurangabad Taxi"],
  ["Mumbai to Aurangabad One Way Taxi", "Mumbai to Aurangabad Car Rental"],
  ["Mumbai to Aurangabad Cab Booking", "Mumbai Aurangabad Taxi Service"],
  ["Mumbai Airport to Aurangabad Taxi", "Mumbai to Sambhaji Nagar Cab"],
  ["Mumbai to Aurangabad Taxi Fare Per Day", "Navi Mumbai to Aurangabad Cab"],
  ["Thane to Aurangabad Cab", "Mumbai to Ajanta Ellora Tour Package"],
  ["Mumbai to Paithan Cab Service", "Mumbai to Aurangabad MIDC"],
  ["Mumbai to Sambhajinagar Cab", "Mumbai to Chhatrapati Sambhajinagar Cab"],
  ["Mumbai to Sambhajinagar Taxi Service", "Mumbai to Aurangabad Taxi Service"],
  ["Mumbai to Sambhajinagar Cab Service", "Mumbai to Aurangabad Cab Service"],
  ["Mumbai to Sambhajinagar One Way Cab", "Mumbai to Aurangabad One Way Taxi"],
  ["One Way Mumbai to Sambhajinagar Cab", "Mumbai Airport to Sambhajinagar Cab"],
  ["Mumbai to Aurangabad Innova Crysta Cab", "Mumbai to Sambhajinagar Ertiga Cab"],
  ["Mumbai to Aurangabad Outstation Taxi", "Best Mumbai to Sambhajinagar Cab Booking"],
  ["Mumbai to Ellora Caves Cab", "Mumbai to Grishneshwar Jyotirlinga Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Aurangabad Cab Service",
    WhyChoosedescription: "Shreesha Tours & Travels offers dependable Mumbai to Aurangabad cab services with comfortable vehicles, professional drivers, and flexible travel options for business, family, tourism, and pilgrimage journeys."
  },
  {
    WhyChooseheading: "Convenient Doorstep Pickup & Drop",
    WhyChoosedescription: "Travel without hassle with pickup from your home, hotel, office, airport, or railway station in Mumbai and direct drop-off anywhere in Aurangabad."
  },
  {
    WhyChooseheading: "Wide Selection of Comfortable Vehicles",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium cars according to your travel needs and passenger count."
  },
  {
    WhyChooseheading: "One Way, Round Trip & Multi-Day Packages",
    WhyChoosedescription: "Book a one-way taxi, round-trip cab, or customized multi-day travel package with flexible pickup and return schedules."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long-Distance Travel",
    WhyChoosedescription: "Our skilled chauffeurs ensure a safe, smooth, and comfortable journey while following the best highway routes for timely arrivals."
  },
  {
    WhyChooseheading: "Perfect for Tourism & Pilgrimage",
    WhyChoosedescription: "Visit famous attractions like Ajanta Caves, Ellora Caves, Bibi Ka Maqbara, Grishneshwar Jyotirlinga, Daulatabad Fort, and other nearby destinations with our customized cab service."
  },
  {
    WhyChooseheading: "Well-Maintained Cars for Comfortable Travel",
    WhyChoosedescription: "Our fleet is regularly serviced and features clean interiors, air-conditioned cabins, comfortable seating, and sufficient luggage space for long journeys."
  },
  {
    WhyChooseheading: "Easy Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Book your Mumbai to Aurangabad cab quickly with transparent pricing, prompt customer support, and hassle-free reservation assistance."
  }
]

};

const faqData = [
  {
    question: "Does Shreesha Tours & Travels provide Mumbai to Aurangabad Cab Service?",
    answer: "Yes, we provide Mumbai to Aurangabad cab services for one-way trips, round trips, business travel, family tours, and pilgrimage journeys."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Aurangabad?",
    answer: "Yes, one-way taxi services are available with pickup from any location in Mumbai."
  },
  {
    question: "Which vehicles are available for Mumbai to Aurangabad travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I book a round-trip Mumbai to Aurangabad taxi?",
    answer: "Yes, we offer flexible round-trip taxi packages according to your travel schedule."
  },
  {
    question: "Can I include Ajanta and Ellora Caves in my trip?",
    answer: "Yes, your itinerary can be customized to include Ajanta Caves, Ellora Caves, Grishneshwar Temple, Daulatabad Fort, and other nearby attractions."
  },
  {
    question: "Do you provide pickup from Mumbai Airport and railway stations?",
    answer: "Yes, pickup is available from Mumbai Airport, railway stations, hotels, homes, offices, and other preferred locations."
  },
  {
    question: "Is this cab service suitable for family travel?",
    answer: "Yes, our spacious and comfortable vehicles are ideal for families, senior citizens, groups, and corporate travellers."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, permits, and other applicable charges depend on the selected package and are clearly explained before booking."
  },
  {
    question: "Is Mumbai to Aurangabad cab service available every day?",
    answer: "Yes, Shreesha Tours & Travels provides daily cab booking assistance based on advance reservations and vehicle availability."
  },
  {
    question: "How can I book a Mumbai to Aurangabad Cab?",
    answer: "Simply share your pickup location, travel date, destination, passenger details, and preferred vehicle to receive a fare quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Deepak Kulkarni",
    feedback: "Our Mumbai to Aurangabad trip with Shreesha Tours & Travels was excellent. The cab was clean, the driver was experienced, and the journey was comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Joshi",
    feedback: "We booked an Innova Crysta for our family visit to Ajanta and Ellora. The vehicle was spacious, the service was professional, and the complete trip was hassle-free.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Aurangabad Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-aurangabad-cab.webp",
  "description":
    "Book Mumbai to Aurangabad Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs between Mumbai and Aurangabad with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for business travel, family trips, Ajanta-Ellora sightseeing, and airport transfers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-aurangabad-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Mumbai to Aurangabad Cab | Comfortable Outstation Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Aurangabad Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable travel between Mumbai and Aurangabad with 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Aurangabad Cab, Aurangabad to Mumbai One Way Taxi, Aurangabad to Mumbai Taxi, One Way Cab Mumbai to Aurangabad, Mumbai to Aurangabad Taxi Fare, Mumbai to Aurangabad Taxi, Mumbai to Aurangabad One Way Taxi, Mumbai to Aurangabad Cab Service, Mumbai to Aurangabad Taxi Booking, Mumbai to Aurangabad Car Rental, Mumbai to Aurangabad Outstation Cab, Mumbai to Aurangabad Round Trip Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoaurangabadcab;